<form (ngSubmit)="submitForm()"
  class="cx-place-order-form"
  [formGroup]="checkoutSubmitForm">
  @for (orderInfoFieldItem of orderInfoFields; track orderInfoFieldItem; let index = $index) {
    @if (orderInfoFieldItem.orderInfoField && !readonly) {
      <label class="form-group form justify-content-between w-100" [ngClass]="orderInfoFieldItem.orderInfoField.mandatory?'label-mandatory':''">
        <span class="label-content">
          {{ orderInfoFieldItem.orderInfoField.shopText }}:
          @if (orderInfoFieldItem.orderInfoField.mandatory) {
            <sup>*</sup>
          }
        </span>
        @if (orderInfoFieldItem.orderInfoField.fieldId; as fieldId) {
          <input class="form-control" type="text"
            [maxLength]="orderInfoFieldItem.orderInfoField.numeric ? '' : orderInfoFieldItem.orderInfoField.length"
            [formControlName]="fieldId"
            [placeholder]="orderInfoFieldItem.orderInfoField.placeholderText?.length > 0 ? orderInfoFieldItem.orderInfoField.placeholderText : orderInfoFieldItem.orderInfoField.shopText"
            [disableTooltip]="orderInfoFieldItem.orderInfoField.toolTipText?.length === 0"
            ngbTooltip="{{orderInfoFieldItem.orderInfoField.toolTipText}}" placement="top"/>
            @if (orderInfoFieldItem.orderInfoField.mandatory) {
              <cx-form-errors [control]="checkoutSubmitForm.get(fieldId)"></cx-form-errors>
            }
          }
        </label>
      } @else {
        @if (orderInfoFieldItem.value) {
          <p>
            <span class="label-content">
              {{ orderInfoFieldItem.orderInfoField.shopText }}:
              @if (orderInfoFieldItem.orderInfoField.mandatory) {
                <sup>*</sup>
              }
            </span>
            @if (readonly) {
              <span class="ml-2">{{ orderInfoFieldItem.value }}</span>
            }
          </p>
        }
      }
    }
    @if (!readonly) {
      <label class="form-group justify-content-between w-100 label-mandatory">
        <span class="label-content">
          {{ 'checkoutOrder.checkoutSubmitForm.YourAdditionalInformation.label' | cxTranslate }}:
          <sup>*</sup>
        </span>
        <input class="form-control"
          type="text"
          [maxLength]="consignmentInfoAllowedMaxLength"
          formControlName="consignmentInfo"
          placeholder="{{ 'checkoutOrder.checkoutSubmitForm.YourAdditionalInformation.placeholder' | cxTranslate }}"/>
          <cx-form-errors [control]="checkoutSubmitForm.get('consignmentInfo')"></cx-form-errors>
        </label>
      } @else {
        @if (readonly && (orderDetails$ | async).consignmentInfo; as consignment) {
          <p>
            <span class="label-content">
              {{ 'checkoutOrder.checkoutSubmitForm.YourAdditionalInformation.label' | cxTranslate }}:
              <sup>*</sup>
            </span>
            <span class="ml-2">{{ consignment }}</span>
          </p>
        }
      }
    </form>
